import store from './module/store'
import routes from './module/routes'

export default {
	name: 'checkin-site',
	store: store,
	routes: routes
}